export enum Pixel {
    White = 0,
    Unknown = 1,
    Black = 2,
}


// WEBPACK FOOTER //
// ./src/Pixel.ts